import { render } from "./UpdateProfileForm.vue?vue&type=template&id=700afcf0&scoped=true"
import script from "./UpdateProfileForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileForm.vue?vue&type=script&lang=js"

import "./UpdateProfileForm.vue?vue&type=style&index=0&id=700afcf0&scoped=true&lang=css"
import "./UpdateProfileForm.vue?vue&type=style&index=1&id=700afcf0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700afcf0"]])

export default __exports__